<h5>Histórico da cesta atual</h5>

<div class="container mt-3 mx-auto">
  <div class="row">
    <div class="col">
      <table class="table table-hover">
        <div class="col-md-4">
          <th class="d-flex">
            <input type="checkbox" class="form-check" id="apenasAlteracoesManuais" (change)="changeCheck($event)"
              ngbTooltip="Exibe apenas os históricos relativos a alterações manuais.">
            <label class="form-check-label" for="apenasAlteracoesManuais" style="color: #01498F;"><b>Apenas alterações manuais <i
                  class="fa fa-filter"></i></b></label>
          </th>
        </div>
      </table>
    </div>
    <div class="col-auto">
      <button type="button" class="btn btn-primary" (click)="voltar()">Voltar
      </button>
    </div>
  </div>

  <div>

    <bn-paginacao [total]="atributosPaginacao.count" [tamanhoPagina]="atributosPaginacao.pageSize"
      [numPagina]="atributosPaginacao.page" [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">

      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th id="col-dataCriacao" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataCriacao'"
                  [nomeAtributoExibicao]="'Dt. criação'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-usuarioResponsavel" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'usuarioResponsavel'"
                  [nomeAtributoExibicao]="'Usuário responsável'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-dataReferencia" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataReferencia'"
                  [nomeAtributoExibicao]="'Dt. referência'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-valorTotalLimiteContratacao" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'valorTotalLimiteContratacao'"
                  [nomeAtributoExibicao]="' Valor total limite contr.'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-valorTotalRecursosFundo" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'valorTotalRecursosFundo'"
                  [nomeAtributoExibicao]="'Valor total (recursos fundo)'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-comentarios" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'comentarios'"
                  [nomeAtributoExibicao]="'Comentários'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>

            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let historico of historico">
              <td>{{ historico.dataCriacao | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
              <td>{{ historico.usuarioResponsavel }}</td>
              <td>{{ historico.dataReferencia | date: 'dd/MM/yyyy '}}</td>
              <td>{{ historico.valorTotalLimiteContratacao}}</td>
              <td>{{ historico.valorTotalRecursosFundo}}</td>
              <td>{{ historico.comentarios }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </bn-paginacao>
  </div>
</div>